import React from 'react';

import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import { GTMServices } from '@services/gtm';

import persona02Img from '../../../../../assets/images/persona02.svg';
import { Wrapper, Image, Content, Title, Text, LinkButton } from './styles';

const NewsLaborProposalBanner = () => {
  const handleOpenLink = () => {
    GTMServices.dispatchGtm(
      'Tomador',
      'Processos',
      'Banner Tomador/Trabalhista',
      'Clique'
    );

    window.location = `${getSessionItem(
      'PLATAFORMA_URL'
    )}quote/modalities-express`;
  };

  return (
    <Wrapper data-testid="news-labor-proposal-banner">
      <Image src={persona02Img} />
      <Content>
        <Title>Aqui na Junto, você é nossa prioridade!</Title>
        <Text>
          <span>
            Simplificamos sua forma de preenchimento de propostas trabalhistas.
          </span>{' '}
          Agora ao inserir o número do processo, buscaremos as informações
          automaticamente, de maneira ágil e simples.
        </Text>
        <LinkButton
          data-testid="news-labor-proposal-banner-button"
          onClick={() => handleOpenLink()}
        >
          Confira agora mesmo
        </LinkButton>
      </Content>
    </Wrapper>
  );
};

export default NewsLaborProposalBanner;
